import { datatableFormaterStringified } from '@clickadilla/datatable-formatter';
import urlFormatter from '@/services/url-formatter';
import http, { cancelTokenNames } from '@/services/http';
import createOfferFromResource from '@/classes/createPrivateOffer';
import createPrivateOfferService from '@/classes/createPrivateOfferService';
import createOfferStoreRequest from './createOfferStoreRequest';

const getURL = urlFormatter({
  list: '/api/v1/admin/private-offers',
  create: '/api/v1/admin/private-offers',
  services: '/api/v1/admin/private-offers/services',
  archive: '/api/v1/admin/private-offers/{privateOffer}/archive',
  unarchive: '/api/v1/admin/private-offers/{privateOffer}/unarchive',
  complete: '/api/v1/admin/private-offers/{privateOffer}/complete',
  show: '/api/v1/admin/private-offers/{privateOffer}',
  update: '/api/v1/admin/private-offers/{privateOffer}',
  publicShow: '/api/v1/private-offers/{slug}',
});

export default {
  async table({
    headers,
    options,
    search,
  }) {
    const requestBody = datatableFormaterStringified({
      headers,
      options,
      search,
    });
    const statusAll = search.status === '';
    const endpoint = getURL('list');
    const response = await http.get(`${endpoint}?${requestBody}&is_all=${statusAll}`, {
      applyCancelAdapter: cancelTokenNames.PRIVATE_OFFERS_TABLE,
    });

    return {
      items: response.data.data.map(createOfferFromResource),
      totalItemsCount: response.data.recordsFiltered,
    };
  },

  async create(payload) {
    const endpoint = getURL('create');
    const { data } = await http.post(endpoint, createOfferStoreRequest(payload));

    return data;
  },

  async services(params = {}) {
    const endpoint = getURL('services');
    const response = await http.get(endpoint, { params });

    return response.data.data.map(createPrivateOfferService);
  },

  async archive(privateOfferId) {
    const endpoint = getURL('archive', { privateOffer: privateOfferId });
    const { data } = await http.post(endpoint);

    return data;
  },

  async unarchive(privateOfferId) {
    const endpoint = getURL('unarchive', { privateOffer: privateOfferId });
    const { data } = await http.post(endpoint);

    return data;
  },

  async complete(privateOfferId) {
    const endpoint = getURL('complete', { privateOffer: privateOfferId });
    const { data } = await http.post(endpoint);

    return data;
  },
  async show(privateOfferId) {
    const endpoint = getURL('show', { privateOffer: privateOfferId });
    const { data } = await http.get(endpoint);

    return createOfferFromResource(data.data);
  },

  async update(privateOfferId, payload) {
    const endpoint = getURL('update', { privateOffer: privateOfferId });
    const { data } = await http.patch(endpoint, createOfferStoreRequest(payload));

    return data;
  },

  async publicShow(slug) {
    const endpoint = getURL('publicShow', { slug });
    const { data } = await http.get(endpoint);

    return data;
  },
};
